module.exports = __webpack_public_path__ + "img/2.16afdef7.png";